import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/dispatch-space-action-receipt.ts
const dispatchSpaceActionClosedReasonCodeSchema = z$1.enum(["space_action.context_expired", "space_action.context_mismatch"]);
const dispatchSpaceActionReceiptSchema = z$1.discriminatedUnion("status", [
	z$1.strictObject({
		status: z$1.literal("proposal_saved_locally"),
		actionType: z$1.enum([
			"post_message",
			"post_status",
			"stay_silent"
		]),
		attemptId: z$1.string().min(1),
		contextId: z$1.string().min(1),
		dispatchId: z$1.string().min(1),
		recordedAtMs: z$1.number().int().nonnegative(),
		contextState: z$1.enum(["active", "expired"]),
		coordinatorAcceptance: z$1.literal("unconfirmed"),
		publication: z$1.literal("unconfirmed")
	}),
	z$1.strictObject({
		status: z$1.literal("rejected_closed"),
		reasonCode: dispatchSpaceActionClosedReasonCodeSchema,
		coordinatorAcceptance: z$1.literal("unconfirmed"),
		publication: z$1.literal("unconfirmed")
	}),
	z$1.strictObject({
		status: z$1.literal("outcome_unknown"),
		reasonCode: z$1.literal("space_action.recording_outcome_unknown"),
		coordinatorAcceptance: z$1.literal("unconfirmed"),
		publication: z$1.literal("unconfirmed")
	})
]);
const dispatchSpaceActionToolResultSchema = z$1.strictObject({ receipt: dispatchSpaceActionReceiptSchema });
//#endregion
export { dispatchSpaceActionClosedReasonCodeSchema, dispatchSpaceActionReceiptSchema, dispatchSpaceActionToolResultSchema };

//# sourceMappingURL=dispatch-space-action-receipt.js.map